// The kiosk's official frame: the Department of Health header (seal, department, program title in Urdu
// and English, Pakistan time with the Hijri date), the facility strip and the footer. Every patient
// screen sits inside it, in the same identity as the program's public pages.

import type { ReactNode } from 'react';
import { Clock, PROGRAM } from '../ui/site.tsx';
import type { Lang } from './strings.ts';

const DEPT_UR = 'محکمہ صحت';
const GOV_UR = 'حکومت آزاد جموں و کشمیر';

export function KioskHeader({ lang, onSealDown, onSealUp, children }: {
  lang: Lang; onSealDown?: () => void; onSealUp?: () => void; children?: ReactNode;
}) {
  const ur = lang === 'ur';
  return (
    <header className="k-header k-gov">
      <div className="k-brand">
        <img src="/brand/seal.svg" alt="" className="k-seal" width={72} height={72} onPointerDown={onSealDown} onPointerUp={onSealUp} onPointerLeave={onSealUp} draggable={false} />
        <div>
          <div className="k-dept">{ur ? DEPT_UR : PROGRAM.en}</div>
          <div className="k-gov-sub">{ur ? GOV_UR : PROGRAM.sub}</div>
        </div>
      </div>
      <div className="k-program">
        <div className="k-program-ur" lang="ur" dir="rtl">{PROGRAM.programUr}</div>
        <div className="k-program-en" lang="en" dir="ltr">{PROGRAM.program}</div>
      </div>
      <div className="k-status">
        <div className="k-clock" lang="en" dir="ltr"><Clock /></div>
        {children && <div className="k-badges">{children}</div>}
      </div>
    </header>
  );
}

export function FacilityStrip({ lang, facility, kioskId }: {
  lang: Lang; facility: { name: string; name_ur: string; district: string; district_ur: string }; kioskId: string;
}) {
  const ur = lang === 'ur';
  return (
    <div className="k-strip" role="note">
      <span className="k-strip-badge">{ur ? 'مرکزِ صحت' : 'HEALTH FACILITY'}</span>
      <span className="k-strip-name">{ur ? facility.name_ur : facility.name}</span>
      <span className="k-strip-district">{ur ? `ضلع ${facility.district_ur}` : `District ${facility.district}`}</span>
      <span className="k-strip-id" lang="en" dir="ltr">KIOSK {kioskId}</span>
    </div>
  );
}

export function KioskFooter({ lang }: { lang: Lang }) {
  const ur = lang === 'ur';
  return (
    <footer className="k-gov-footer">
      <span className="k-emergency">{ur ? 'ہنگامی صورت میں فوراً عملے کو بتائیں' : 'In an emergency, tell the staff immediately'}</span>
      <span className="k-privacy">{ur ? `آپ کی معلومات خفیہ رکھی جاتی ہیں · ${DEPT_UR}، ${GOV_UR}` : 'Your information is kept confidential · Department of Health, Government of AJK'}</span>
      <span className="k-powered" lang="en" dir="ltr">POWERED BY <b>MOVO-X</b></span>
    </footer>
  );
}
